var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCommentOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.305 23L12 22.25L15 17H19.5C19.8978 17 20.2794 16.842 20.5607 16.5607C20.842 16.2794 21 15.8978 21 15.5V6.5C21 6.10218 20.842 5.72064 20.5607 5.43934C20.2794 5.15804 19.8978 5 19.5 5H4.5C4.10218 5 3.72064 5.15804 3.43934 5.43934C3.15804 5.72064 3 6.10218 3 6.5V15.5C3 15.8978 3.15804 16.2794 3.43934 16.5607C3.72064 16.842 4.10218 17 4.5 17H11.25V18.5H4.5C3.70435 18.5 2.94129 18.1839 2.37868 17.6213C1.81607 17.0587 1.5 16.2956 1.5 15.5V6.5C1.5 5.70435 1.81607 4.94129 2.37868 4.37868C2.94129 3.81607 3.70435 3.5 4.5 3.5H19.5C20.2956 3.5 21.0587 3.81607 21.6213 4.37868C22.1839 4.94129 22.5 5.70435 22.5 6.5V15.5C22.5 16.2956 22.1839 17.0587 21.6213 17.6213C21.0587 18.1839 20.2956 18.5 19.5 18.5H15.87L13.305 23Z",
    fill: "#E17100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H6V9.5H18V8Z",
    fill: "#E17100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.5H6V14H13.5V12.5Z",
    fill: "#E17100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommentOutline);
export default __webpack_public_path__ + "static/media/ic-comment-outline.640b5721c5dcd4c233abb4ee2fdc06c2.svg";
export { ForwardRef as ReactComponent };